(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-sellers-homepage"] && !Shopify.designMode) return;
  try {
    
// Best Sellers slider with proper page-based dots
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.homepage-bestsellers-section').forEach(section => {
    const container = section.querySelector('.homepage-bestsellers-cards');
    const cards = Array.from(container.querySelectorAll('.homepage-bestsellers-card'));
    if (!container || cards.length === 0) return;

    // Determine cardsPerView based on width
    function getCardsPerView() {
      const w = window.innerWidth;
      if (w >= 1024) return 4;
      if (w >= 600)  return 2.5;
      return 1.5;
    }

    let cardsPerView = getCardsPerView();
    const pageCount  = Math.ceil(cards.length / cardsPerView);

    // Build dots
    const dotsContainer = document.createElement('div');
    dotsContainer.className = 'homepage-bestsellers-dots';
    const dots = [];

    for (let i = 0; i < pageCount; i++) {
      const dot = document.createElement('span');
      dot.className = 'homepage-bestsellers-dot';
      dot.addEventListener('click', () => {
        const gap = parseInt(getComputedStyle(container).gap) || 0;
        const scrollPos = i * cardsPerView * (cards[0].offsetWidth + gap);
        container.scrollTo({ left: scrollPos, behavior: 'smooth' });
      });
      dotsContainer.appendChild(dot);
      dots.push(dot);
    }

    container.after(dotsContainer);

    // Activate first dot
    if (dots[0]) dots[0].classList.add('active');

    // Update active dot on scroll (mobile/tablet)
    let ticking = false;
    container.addEventListener('scroll', () => {
      if (ticking) return;
      window.requestAnimationFrame(() => {
        const gap = parseInt(getComputedStyle(container).gap) || 0;
        const pos = container.scrollLeft;
        const index = Math.min(
          pageCount - 1,
          Math.round(pos / ((cards[0].offsetWidth + gap) * cardsPerView))
        );
        dots.forEach((d, idx) => d.classList.toggle('active', idx === index));
        ticking = false;
      });
      ticking = true;
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-pro-fstm-stack"] && !Shopify.designMode) return;
  try {
    
// data-disc-bound guard: section JS can execute once per section present on
// the page — the guard makes binding idempotent so a button never gets two
// toggle handlers even if both PDP stack sections ship JS for .ppv2-disc-btn.
document.querySelectorAll('.ppv2-disc-btn').forEach(function (btn) {
  if (btn.dataset.discBound) return;
  btn.dataset.discBound = '1';
  btn.addEventListener('click', function () {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    var isOpen = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!isOpen));
    if (isOpen) { panel.setAttribute('hidden', ''); } else { panel.removeAttribute('hidden'); }
    var glyph = btn.querySelector('.ppv2-disc-glyph');
    if (glyph) glyph.innerHTML = isOpen ? '+' : '−';
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-pro-v2-stack"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.ppv2-disc-btn').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    var isOpen = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!isOpen));
    if (isOpen) { panel.setAttribute('hidden', ''); } else { panel.removeAttribute('hidden'); }
    var glyph = btn.querySelector('.ppv2-disc-glyph');
    if (glyph) glyph.innerHTML = isOpen ? '+' : '−';
  });
});

  } catch(e) { console.error(e); }
})();
})();
